$(document).ready(function () {
	let $formRegisterAll = $('.form-register');
	let $formRegister = $('.form-register-index');
	let $formRegisterConfirm = $('.form-register-confirm');
	let $formRegisterUserdata = $('.form-register-userdata');
	let $formRegisterCard = $('.form-register-card');

	$formRegisterAll.find('.btn-skip-form').click(function () {
		let $currentForm = $(this).closest('.form-register');
		let $nextForm = $currentForm.next('.form-register');

		if ($nextForm.length) {
			$currentForm.hide();
			$nextForm.show();
		} else {
			location.href = '/account'
		}

		return false;
	});

	$formRegister.find('.form-group.required').each(function () {
		$(this).find('input, select').attr('required', 'required');
	});

	/*let tmInputPhone;
	$formRegister.find('input[name=phone]').on('input', function () {
		clearTimeout(tmInputPhone);

		let $self = $(this);

		tmInputPhone = setTimeout(function () {
			let params = {
				phone: $self.val()
			};

			if (params.phone) {
				$.get('/auth/check_phone_exists', params, function (data) {
					if (data.phone_exists) {
						$formRegister.find('.reg-content').slideUp();
						$formRegister.find('.to-auth-content').slideDown();
					} else {
						$formRegister.find('.reg-content').slideDown();
						$formRegister.find('.to-auth-content').slideUp();
					}
				});
			}
		}, 500);
	});*/

	$formRegister.find('.btn-to-auth').click(function () {
		let phone = $formRegister.find('[name=phone]').val();
		location.href = $(this).attr('href') + '?phone=' + phone;
		return false;
	});

	$formRegister.submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();

		Auth.clearMsg($formRegister);

		$.post(route, params, function (data) {
			if (data.error) {
				$formRegister.trigger('reload-btn');
				Auth.errorMsg($formRegister, data.msg);
			} else {
				$formRegister.hide();
				$formRegisterConfirm.show();
				$formRegisterConfirm.find('input:visible').first().focus();
			}
		}).fail(function () {
			$formRegister.trigger('reload-btn');
			Auth.errorMsg($formRegister, 'Произошла неизвестная ошибка');
		});

		return false;
	});

	$formRegisterConfirm.submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();

		Auth.clearMsg($formRegisterConfirm);

		$.post(route, params, function (data) {
			$formRegister.hide();
			$formRegisterConfirm.show();

			if (data.error) {
				Auth.errorMsg($formRegisterConfirm, data.msg);
				$formRegisterConfirm.trigger('reload-btn');
			} else {
				$formRegisterConfirm.hide();
				$formRegisterUserdata.show();
				$formRegisterUserdata.find('input:visible').first().focus();

				if (data.userinfo_fields) {
					for(let fieldName in data.userinfo_fields) {
						let id = data.userinfo_fields[fieldName];
						let $input = $formRegisterUserdata.find(`[name=${fieldName}]`);
						$input.attr('name', `q[${id}]`);
					}
				}
			}
		}).fail(function () {
			$formRegisterConfirm.trigger('reload-btn');
			Auth.errorMsg($formRegisterConfirm, 'Произошла неизвестная ошибка');
		});

		return false;
	});

	$formRegisterUserdata.submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();

		Auth.clearMsg($formRegisterUserdata);

		$.post(route, params, function (data) {
			if (data.error) {
				Auth.errorMsg($formRegisterUserdata, data.msg);
				$formRegisterUserdata.trigger('reload-btn');
			} else {
				$formRegisterUserdata.hide();
				$formRegisterCard.show();
			}
		}).fail(function () {
			$formRegisterUserdata.trigger('reload-btn');
			Auth.errorMsg($formRegisterUserdata, 'Произошла неизвестная ошибка');
		});

		return false;
	});

	$formRegisterCard.submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();

		Auth.clearMsg($formRegisterCard);

		$.post(route, params, function (data) {
			if (data.error) {
				Auth.errorMsg($formRegisterCard, data.msg);
				$formRegisterCard.trigger('reload-btn');
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});
	$formRegisterCard.find('[name=hascard]').change(function () {
		let id = $(this).attr('id');
		$formRegisterCard.find('.hascard-container').hide();
		$formRegisterCard.find('.hascard-container[data-type="'+id+'"]').show();

		Auth.clearMsg($formRegisterCard);
	});
});
